export default __webpack_public_path__ + "locales/lv/ResetApplicationDialog.json?hash=5dba062d39a44d18cafd658f0fb9f655";